import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import PrivacyPolicy from './pages/PrivacyPolicy';
import SlopeSliders from './pages/SlopeSliders';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/slope-sliders" element={<SlopeSliders />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
    </Routes>
  );
}
